import styled from 'styled-components'

export const Modal = styled.div`
    .modal {
        background-color: rgba(0, 0, 0, 0.4);
        visibility: hidden;
        display: block;

        &.visible {
            .modal-content {
                opacity: 1;
                transform: scale(1);
            }
        }
    }

    .modal-content {
        opacity: 0;

        transform: scale(0.8);
        transition-delay: 0.3s;
        transition: opacity 0.2s linear, transform 0.3s cubic-bezier(0, 0, 0, 2.14);
    }

    .modal-dialog {
        display: flex;
        align-items: center;
        height: 100%;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        white-space: normal;
        max-height: 70vh;
    }

    .modal-footer {
        justify-content: space-between;
    }
`
